"use strict";var _global=require("./global");exports.__esModule=!0,exports.getCookie=getCookie,exports.setCookie=setCookie;/**
 * 设置Cookie
 * @param name
 * @param value
 * @param overtime
 * @param domain
 */function setCookie(a,b,c,d){var e="";if(c){var f=new Date;f.setTime(f.getTime()+c),e="; expires="+f.toUTCString()}d||(d=_global.document.domain),_global.document.cookie=a+"="+(b||"")+e+("; path=/; domain="+d)}/**
 * 获取 Cookie
 * @param name
 */function getCookie(a){var b="; "+_global.document.cookie,c=b.split("; "+a+"=");return 2===c.length?decodeURIComponent(c.pop().split(";").shift()):null}